var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-bulk",
    clipPath: "url(#clip0_1_277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.94444 20.8334C5.83333 20.8334 4.72222 19.8611 4.16667 19.4445C1.38889 17.5 0.555556 16.8056 0 16.3889V22.2222C0 22.9892 0.621962 23.6111 1.38889 23.6111H12.5C13.2669 23.6111 13.8889 22.9892 13.8889 22.2222V16.3889C13.3333 16.8056 12.5 17.5 9.72222 19.4445C9.16667 19.8611 8.05556 20.8334 6.94444 20.8334ZM12.5 12.5H1.38889C0.621962 12.5 0 13.122 0 13.8889V14.5834C1.11111 15.4167 0.972222 15.4167 5 18.3334C5.41667 18.6111 6.25 19.4445 6.94444 19.4445C7.63889 19.4445 8.47222 18.6111 8.88889 18.4722C12.9167 15.5556 12.7778 15.5556 13.8889 14.7222V13.8889C13.8889 13.122 13.2669 12.5 12.5 12.5ZM23.6111 8.33336H9.72222C8.95529 8.33336 8.33333 8.95532 8.33333 9.72225V11.1111H12.5C13.9414 11.1111 15.1298 12.2144 15.2652 13.6207L15.2778 13.6111V19.4445H23.6111C24.378 19.4445 25 18.8225 25 18.0556V9.72225C25 8.95532 24.378 8.33336 23.6111 8.33336ZM22.2222 13.8889H19.4444V11.1111H22.2222V13.8889ZM6.94444 9.72225C6.94444 8.19057 8.19054 6.94447 9.72222 6.94447H19.4444V2.7778C19.4444 2.01088 18.8225 1.38892 18.0556 1.38892H4.16667C3.39974 1.38892 2.77778 2.01088 2.77778 2.7778V11.1111H6.94444V9.72225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4ce5196f8eee3f0bf4193e01bee64d11.svg";
export { ForwardRef as ReactComponent };